import { BasicProfile, DEFAULT_PROFILE } from "protico-sdk";
import useSWR from "swr";
import { useAppSelector } from ".";
import { getProticoClient } from "../utils/api";
import { checkAddress, getImgproxyUrl } from "../utils/format.utils";
import { fixOldInfuraUrl } from "../utils/ipfs.utils";
import { useWeb3Auth } from "./useWeb3Auth";
import { AIAvatarData } from "../types/types";

export const getStableBasicProfile = async (
  targetAddress: string,
  isUser?: boolean
) => {
  try {
    checkAddress(targetAddress);
  } catch (_) {
    return { ...DEFAULT_PROFILE, aiavatar: null as AIAvatarData | null };
  }
  let name: string;
  let basicProfile: BasicProfile;
  let aiavatar: AIAvatarData | null;
  if (isUser) {
    basicProfile = await getProticoClient().profile.get(
      targetAddress + "?time=" + new Date().getTime()
    );
  } else {
    basicProfile = await getProticoClient().profile.get(targetAddress);
  }
  if (!!basicProfile) {
    name = basicProfile?.name
      ? basicProfile.name
      : generateName(isUser, targetAddress);
  } else {
    basicProfile = DEFAULT_PROFILE;
    name = generateName(isUser, targetAddress);
  }
  let avatar_url = fixOldInfuraUrl(basicProfile?.avatar_url);
  if (avatar_url) {
    avatar_url = getImgproxyUrl(avatar_url);
  }

  try {
    const res = await getProticoClient().api.get(
      "/api/ai_avatar/registry/user/" + targetAddress
    );
    if (!res.data.id) {
      aiavatar = null;
    } else {
      aiavatar = res.data;
    }
  } catch (err) {
    aiavatar = null;
  }

  return {
    ...basicProfile,
    name,
    avatar_url,
    aiavatar,
  };
};

const fetcher = async (targetAddress: string, currentAddress: string) => {
  return await getStableBasicProfile(
    targetAddress,
    targetAddress === currentAddress
  );
};
const useBasicProfile = (address: string) => {
  const { address: currentAddress } = useWeb3Auth();
  const { data, error, mutate } = useSWR(
    [address, currentAddress, "useBasicProfile"],
    fetcher,
    {
      refreshInterval: 60000,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    isPending: !error && !data,
    basicProfile: data ?? {
      ...DEFAULT_PROFILE,
      aiavatar: null as AIAvatarData | null,
    },
    isError: error,
    refetch: mutate,
  };
};
export default useBasicProfile;

function generateName(isUser: boolean, targetAddress: string) {
  return isUser
    ? ""
    : `${targetAddress.slice(0, 8)}...${targetAddress.slice(-3)}`;
}
